import _ from 'underscore';

const favorites = (data) => _(data).chain().values().flatten().value();

export default {
	favorites
};
